/* eslint no-shadow: ["error", { "allow": ["state"] }]	*/
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
	questions: {},
	score: 0,
	time: null,
	answeredQuestions: 0,
	userScore: 0
};

const getters = {
	getScore: (state) => {
		return state.score;
	},
	answeredQuestions: (state) => {
		return state.answeredQuestions;
	},
	getUserScore: (state) => {
		return state.userScore;
	}
};

const mutations = {
	setScore: (state) => {
		state.score += 1;
	},
	setAnsweredQuestions: (state) => {
		state.answeredQuestions += 1;
	},
	resetQuiz: (state) => {
		state.score = 0;
		state.answeredQuestions = 0;
	},
	setUserScore: (state, data) => {
		state.userScore = data;
	}
};

const actions = {
	
};

export default {
	state,
	actions,
	getters,
	mutations
};
